export default __webpack_public_path__ + "static/media/debate_31.917dd5d4.JPG";